// 手机号校验
export function isValidPhoneNumber(phoneNumber: string): boolean {
  const regExr =
    /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;

  return regExr.test(phoneNumber);
}
